import { render } from "./mairie-page.vue?vue&type=template&id=c6fb9fa4&scoped=true"
import script from "./mairie-page.vue?vue&type=script&lang=js"
export * from "./mairie-page.vue?vue&type=script&lang=js"

import "./mairie-page.scss?vue&type=style&index=0&id=c6fb9fa4&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fb9fa4"]])

export default __exports__